import { render } from "./ImageForm.vue?vue&type=template&id=d3411068&scoped=true"
import script from "./ImageForm.vue?vue&type=script&lang=js"
export * from "./ImageForm.vue?vue&type=script&lang=js"

import "./ImageForm.vue?vue&type=style&index=0&id=d3411068&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3411068"]])

export default __exports__